<template>
    <div>
        <SideBar/>
        <div class="wrapper">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import SideBar from '@/components/layout/SideBar';

  require('../asset2/css/main.min.css');

export default {
  name: 'DefaultLayout',
  computed: {
    ...mapGetters({
      hasWhite: 'hasWhiteBackground'
    })
  },
  components: {
    SideBar
  }
}
</script>

<style scoped>

</style>
